import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-other-material',
  templateUrl: './other-material.component.html',
  styleUrls: ['./other-material.component.scss']
})
export class OtherMaterialComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
